import { render, staticRenderFns } from "./createAgentApp.vue?vue&type=template&id=15ca504c&scoped=true&"
import script from "./createAgentApp.vue?vue&type=script&lang=js&"
export * from "./createAgentApp.vue?vue&type=script&lang=js&"
import style0 from "./createAgentApp.vue?vue&type=style&index=0&id=15ca504c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ca504c",
  null
  
)

export default component.exports